import { Box, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import MainHeader from "../../shared/MainHeader";
import { useFormik } from "formik";
import * as Yup from "yup";
import TextInput from "../../shared/TextInput";
// import TextAreaInput from "../../shared/TextAreaInput";
import ButtonCommon from "../../shared/ButtonCommon";
import SingleFileInput from "../../shared/SingleFileInput";
import { POST } from "../../api/ApiService";
import { useSelector } from "react-redux";
// import SelectInput from "../../shared/SelectInput";
import { toast } from "react-toastify";
import CaseSearchDropdown from "../../shared/CaseSearchDropdown";

const CreateCourtReport = () => {
  const [selectedFiles, setSelectedFiles] = useState();
  const [clearFile, setClearFile] = useState(false);
  const [resetDropdown, setResetDropdown] = useState(false);

  const userDetails = useSelector((state) => state.userReducer.userDetails);

  // Reset the dropdown reset state after it has been set to true
  useEffect(() => {
    if (resetDropdown) {
      setResetDropdown(false);
    }
  }, [resetDropdown]);

  const handleFileChange = (files) => {
    setClearFile(false);
    setSelectedFiles(files);
  };

  const formik = useFormik({
    initialValues: {
      title: "",
      case: null,
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      case: Yup.object().required("Case is required"),
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();

      formData.append("Title", values.title);
      formData.append("CaseID", values.case.CaseID);
      formData.append("CreatedByUserID", userDetails?.id);
      formData.append("FilePath", selectedFiles);

      POST("court-report/create", formData, true, true)
        .then((resp) => {
          toast.success(resp?.message);
          resetForm();
          setClearFile(true);
          setResetDropdown(true);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    },
  });
  return (
    <Box>
      <MainHeader headingText="Create a Court Report" />

      <Stack
        p={3}
        spacing={{ xs: 2, sm: 2, md: 4 }}
        sx={{
          border: "1px solid #C1C1C1",
          minHeight: "80vh",
        }}
      >
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: "400",
            lineHeight: "18.27px",
            textAlign: "left",
          }}
        >
          Set a title for your report and enter a case number. Then attach your
          report as a Word or PDF document.
        </Typography>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            {/* row one */}
            <Grid container item>
              <Grid
                item
                xs={3}
                sm={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Typography sx={{ textAlign: "left" }}>
                  Title<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>

              <Grid
                item
                xs={9}
                sm={6}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Stack sx={{ width: "100%" }}>
                  <TextInput
                    name="title"
                    placeholder=""
                    onChangeValue={formik.handleChange}
                    onBlurValue={formik.handleBlur}
                    value={formik.values.title}
                    startIcon={false}
                  />

                  {formik.touched.title && formik.errors.title ? (
                    <div
                      style={{
                        fontSize: "smaller",
                        color: "red",
                        textAlign: "left",
                      }}
                    >
                      {formik.errors.title}
                    </div>
                  ) : null}
                </Stack>
              </Grid>
            </Grid>

            {/* row two */}
            <Grid container item>
              <Grid
                item
                xs={3}
                sm={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Typography sx={{ textAlign: "left" }}>
                  Case<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>

              <Grid
                item
                xs={9}
                sm={6}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Stack sx={{ width: "100%" }}>
                  <CaseSearchDropdown
                    name="case"
                    value={formik.values.case}
                    onChange={(event, newValue) => {
                      formik.setFieldValue("case", newValue);
                    }}
                    onBlur={formik.handleBlur}
                    reset={resetDropdown}
                  />

                  {formik.touched.case && formik.errors.case ? (
                    <div
                      style={{
                        fontSize: "smaller",
                        color: "red",
                        textAlign: "left",
                      }}
                    >
                      {formik.errors.case}
                    </div>
                  ) : null}
                </Stack>
              </Grid>
            </Grid>

            {/* row three */}
            {/* <Grid container item>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Typography sx={{ textAlign: "left" }}>
                  Case<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>

              <Grid
                item
                xs={6}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Stack sx={{ width: "100%" }}>
                  <TextAreaInput
                    name="case"
                    placeholder=""
                    onChangeValue={formik.handleChange}
                    onBlurValue={formik.handleBlur}
                    value={formik.values.case}
                    rows={10}
                    helperText=""
                  />
                  {formik.touched.case && formik.errors.case ? (
                    <div
                      style={{
                        fontSize: "smaller",
                        color: "red",
                        textAlign: "left",
                      }}
                    >
                      {formik.errors.case}
                    </div>
                  ) : null}
                </Stack>
              </Grid>
            </Grid> */}

            {/* row four */}
            <Grid container item>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              ></Grid>

              <Grid
                item
                xs={6}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <SingleFileInput
                  onFileChange={handleFileChange}
                  clearFile={clearFile}
                />
              </Grid>
            </Grid>

            {/* row four */}
            <Grid container item>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              ></Grid>

              <Grid
                item
                xs={6}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <ButtonCommon type="submit">Save</ButtonCommon>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Stack>
    </Box>
  );
};

export default CreateCourtReport;
